import { FC, useEffect, useState } from 'react'
import {
  SpectrumBankAccountStatus,
  SpectrumBankAccountStatusLabel,
  SpectrumIdentityTypeEnum,
} from '../../../../common/enums/spectrumBankAccountEnum'
import { ISpectrumBankAccountFilters } from '../hooks/useSpectrumBankAccounts'

interface IProps {
  filters: ISpectrumBankAccountFilters
  setFilters: (filters: ISpectrumBankAccountFilters) => void
}

const selectStyle = {
  color: 'var(--bs-gray-700)',
  backgroundColor: 'var(--bs-gray-100)',
  borderColor: 'var(--bs-gray-100)',
  paddingRight: 13,
  paddingLeft: 13,
  paddingTop: 10,
  paddingBottom: 10,
  outline: 'none',
}

const identityTypeLabels: Partial<Record<SpectrumIdentityTypeEnum, string>> = {
  [SpectrumIdentityTypeEnum.DNI]: 'DNI',
  [SpectrumIdentityTypeEnum.CE]: 'Carné de extranjería',
  [SpectrumIdentityTypeEnum.PASSPORT]: 'Pasaporte',
}

export const SpectrumBankAccountFiltersDrawer: FC<IProps> = ({ filters, setFilters }) => {
  const [localFilters, setLocalFilters] = useState<ISpectrumBankAccountFilters>(filters)

  useEffect(() => {
    setLocalFilters(filters)
  }, [JSON.stringify(filters)])

  const hasTipoIdentidad = Boolean(localFilters.tipoIdentidad)
  const hasNumIdentidad = Boolean(localFilters.numIdentidad)
  const isPartialIdentity = hasTipoIdentidad !== hasNumIdentidad

  return (
    <div
      className='modal modal_outer right_modal filter-drawer-responsive fade scroll h-400px px-20'
      id='modal-spectrum-bank-account-filters'
      role='dialog'
      aria-labelledby='modalSpectrumBankAccountFiltersLabel'
    >
      <div className='modal-dialog' role='document'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h2 className='text-alert mb-0'>Filtros</h2>
            <i className='bi bi-x-lg fs-5 cursor-pointer' data-bs-dismiss='modal'></i>
          </div>

          <div className='modal-body d-flex flex-column gap-4'>
            <div className='form-group d-flex flex-column'>
              <label className='text-muted fs-6 mb-2'>Documento de identidad</label>
              <select
                style={selectStyle}
                className='form-select'
                value={localFilters.tipoIdentidad}
                onChange={(e) =>
                  setLocalFilters((prev) => ({
                    ...prev,
                    tipoIdentidad: e.target.value as SpectrumIdentityTypeEnum | '',
                  }))
                }
              >
                <option value=''>Seleccionar</option>
                {Object.entries(identityTypeLabels).map(([value, label]) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </select>
            </div>

            <div className='form-group'>
              <label className='text-muted fs-6 mb-2'>N° de documento</label>
              <input
                className='form-control form-control-solid'
                placeholder='Ingrese n°'
                minLength={5}
                maxLength={20}
                value={localFilters.numIdentidad}
                onChange={(e) =>
                  setLocalFilters((prev) => ({ ...prev, numIdentidad: e.target.value }))
                }
              />
              {isPartialIdentity && (
                <span className='text-danger fs-8 mt-1 d-block'>
                  Debe ingresar el tipo y número de documento para realizar la búsqueda.
                </span>
              )}
            </div>

            <div className='form-group d-flex flex-column'>
              <label className='text-muted fs-6 mb-2'>Estado</label>
              <select
                style={selectStyle}
                className='form-select'
                value={localFilters.estado}
                onChange={(e) =>
                  setLocalFilters((prev) => ({
                    ...prev,
                    estado: e.target.value as SpectrumBankAccountStatus | '',
                  }))
                }
              >
                <option value=''>Todos</option>
                {Object.entries(SpectrumBankAccountStatusLabel).map(([value, label]) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className='modal-footer py-2'>
            <div className='text-end'>
              <button
                style={{ backgroundColor: '#eee', color: '#969696' }}
                type='button'
                className='btn col m-3'
                data-bs-dismiss='modal'
              >
                Cancelar
              </button>
              <button
                style={{ background: 'var(--color-primary-blue)', color: 'white' }}
                type='button'
                className='btn col m-3 fw'
                disabled={isPartialIdentity}
                data-bs-dismiss={isPartialIdentity ? undefined : 'modal'}
                onClick={() => setFilters(localFilters)}
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
